import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Player } from "video-react";
import 'video-react/dist/video-react.css';
import React from 'react';
import Api from "../../Api/Api";
import { Helmet } from "react-helmet-async";

import Slider from "../Slider";
import { settingsBanners } from "../../Config/Slider";

import Navbar from "../Navbar";
import Latest from "./Latest";
import Trending from "./Trending";
import { isAutheticated } from "../auth/authhelper";
import { API } from "../../API";
import { username } from "../../API";
import axios from "axios";
import { Modal } from "react-bootstrap";
import CategoriesHome from "./Categeries";
const HomeContainer = ({ banner }) => {


  const dummyBanner = {
    image: "https://picsum.photos/1200/400",
    // title: "Discover Your Perfect Content!",
    // description: "Browse through our exclusive collection and find exactly what you need.",
  };
  // console.log("+++++++++", banner, "+++++++++++++++")
  // const [banners, setBanners] = useState([]);
  // const [play, setPlay] = useState("")
  // const [isModalOpen, setModalStatus] = useState(false);
  // const [lessons, setLessons] = useState([]);
  // // const { username } = useParams();
  // const { token } = isAutheticated()

  // useEffect(() => {
  //   const getData = async () => {
  //     const { data } = await Api.getBanners(username);
  //     const banner = data?.map((bannerObj) => bannerObj.bannerimage);
  //     setBanners(banner);
  //   };
  //   getData();
  // }, [username]);
  // console.log(banners);
  // useEffect(() => {
  //   const getLessons = async () => {
  //     try {
  //       const response = await axios
  //         .get(`${API}/api/client/lessons`, {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //           },
  //         })
  //       console.log(response);
  //       setLessons(response.data)
  //     } catch (err) {
  //       console.log(err)
  //     }
  //   }
  //   getLessons()
  // }, [token])

  return (
    <>
      <Helmet>
        <title>Home - OTT Channel | Stream the Best Content</title>
        <meta
          name="description"
          content="Welcome to our OTT Channel, your destination for streaming the best TV shows, movies, and exclusive content."
        />
        <meta
          name="keywords"
          content="OTT Channel, Home, Streaming, TV Shows, Movies, Exclusive Content"
        />
      </Helmet>

      <div className="px-3 px-md-5 px-lg-7">
        <Navbar />
        {/* <div className="container-md mt-3">
        <div className="row">
          {lessons.map((lesson, index) => {
            return <div className="col-lg-3 col-md-6 col-sm-12 me-4" key={index}>
              <div className="card" style={{ "width": "18rem" }}>
                <img className="card-img-top" src={lesson.thumbnail} alt={lesson.title} />
                <div className="card-body">
                  <h5 className="card-title">{lesson.title}</h5>
                  <p className="card-text">{lesson.description}</p>
                  <button
                    onClick={() => { setPlay(lesson.video); setModalStatus(true) }}
                    href="/#" className="btn btn-primary">Play</button>
                </div>
              </div>
            </div>
          })}
          <Modal
            className="modal-container"
            show={isModalOpen}
            onHide={() => { setModalStatus(false); setPlay("") }}
          >
            <Modal.Body style={{ "backgroundColor": "black" }}>
              <Player width="50%" height="50%">
                <source src={play} />
              </Player>
            </Modal.Body>
          </Modal>
        </div> */}
        {banner?.length ? <Slider data={banner} settings={settingsBanners} /> : (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ height: '100vh' }}>
            <div className="position-relative w-100" style={{ height: '100%' }}>
              <img
                src={dummyBanner?.image} // Replace with your dummy image URL
                alt={dummyBanner?.title}
                className="img-fluid w-100"
                style={{ height: '100%', objectFit: 'cover' }} // Set height to 100% and keep objectFit
              />
            </div>
          </div>

        )}
        <div className="py-4"></div>
        <CategoriesHome />

        <Latest />
        <Trending />
        {/* </div> */}
      </div>
    </>
  );
};
export default HomeContainer;
